define((require) => {
    "use strict";

    var Backbone      = require("backbone"),
        Marionette    = require("marionette"),
        template      = require("ui/editor/sceneLoadingScreen/SceneEditorLoadingScreen.tpl"),
        UploadBarView = require("ui/editor/sceneLoadingScreen/UploadBarView"),
        _             = require("underscore"),

        UPLOADS_DONE    = "uploads:done:loading:screen";


    /**
     * This class is used to add an overlay including loadingbars on top of a scene when
     * images are dragged directly to a scene.
     *
     * The Class works directly with ImageModels that are expected to be in an uploading
     * state.
     */
    return Marionette.CompositeView.extend({

        template: template,

        ui: {
            amount: ".amount"
        },

        className: "scene-loading-scene",

        itemViewContainer: ".uploading-bars",

        itemView: UploadBarView,

        collectionEvents: {
            "change:uploading": "_changeUploadingHandler",
            "upload:failed": "_uploadFailedHandler",
            "add remove": "_addRemoveItemHandler"
        },

        _changeUploadingHandler: function(imageModel) {
            this._removeUpload(imageModel);
        },

        _uploadFailedHandler: function(imageModel) {
            this._removeUpload(imageModel);
        },

        _addRemoveItemHandler: function() {
            this._updateCounter();
        },

        initialize: function() {
            // We start with an empty collection.
            this.collection = new Backbone.Collection([]);
        },

        /**
         * Add the image models to the collection, so the loading bar is rendered.
         *
         * @return {ImageModel[]} - Array of <tt>ImageModel</tt>'s.
         * @public
         */
        addUploads: function(imageModels) {
            // First we filter out any models that might already have finished uploading.
            var filteredModels = _.filter(imageModels, (imageModel) => {
                    return imageModel.get("uploading");
                }),

                // We sort files when they get added, to hopefully have the heaviest files at the
                // top. This will prevent them from "jumping around" as they finish. Files that
                // are added later, will be prepended at the front though; and not shuffled into
                // the already existing uploads.
                sortedImageModels = _.sortBy(filteredModels, (imageModel) => {
                    return -imageModel.get("size");
                });

            this.collection.add(sortedImageModels, {at: 0});
        },

        _updateCounter: function() {
            this.ui.amount.html(this.collection.length);

            if (this.collection.length === 0) {
                this.trigger(UPLOADS_DONE);
            }
        },

        /**
         * Removes an image model, to remove its loading bar.
         *
         * @param {ImageModel} - <tt>ImageModel<tt>.
         * @public
         */
        _removeUpload: function(imageModel) {
            this.collection.remove(imageModel);
        }

    }, {
        UPLOADS_DONE: UPLOADS_DONE
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/editor/sceneLoadingScreen/SceneEditorLoadingScreen.js